import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorProviders } from '@core/interceptors/interceptors';
import {
  i18nProviders,
  integrationsProviders,
  monitoringProviders,
  navigationProviders,
  routerProviders,
  storeProviders,
  uiProviders,
} from './index';

export const appConfig: ApplicationConfig = {
  providers: [
    ...integrationsProviders,
    ...navigationProviders,
    ...routerProviders,
    ...storeProviders,
    ...monitoringProviders,
    ...i18nProviders,
    ...uiProviders,
    ...InterceptorProviders,
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
